module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "header": 'Role has changed',
      "headerStyle": 'font-weight: bold; font-size: 24px',
      "maxWidth": '600px',
      "padding": '20px'
    }
  }, [_c('div', {
    staticClass: "center-xs"
  }, [_c('div', {
    staticClass: "mt2 pl-subheading"
  }, [_vm._v("\n      Your account role has been changed by an administrator.\n      "), _c('br'), _vm._v("\n      You must log out then back in to continue.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    staticStyle: {
      "padding": "3px 30px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logOut.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        LOG OUT\n      ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5dc3007b!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/roleChangedModal.vue
// module id = 2430
// module chunks = 61